module.exports = __webpack_public_path__ + "img/question17c3.d54e9e00.png";